import React from "react";
import { Button } from "primereact/button";
import deleteIconImg from "../../../Assets/deleteIcon.png";
import { useDispatch, useSelector } from "react-redux";
import { Dialog } from "primereact/dialog";

import {
  deleteMasterData,
  setMasterError,
} from "../../../Store/Masters/MastersAction";
import {
  // getIsMasterDataLoading,
  getIsError,
} from "../../../Store/Masters/MastersSelectors";
import { useTranslation } from "react-i18next";

const DeleteMasterHead = ({ title }) => {
  const { t } = useTranslation("master");
  return (
    <div>
      <div className="delete-head">
        <img
          src={deleteIconImg}
          alt="delete icon"
          width="30px"
          height="30px"
        ></img>
        <div className="text-xl font-light">
          {" "}
          {t("Delete")} {t(title)}
        </div>
      </div>
    </div>
  );
};

export const DeleteButton = (props) => {
  const {
    selectedItems,
    setSelectedItems,
    masterType,
    title,
    viewConfig,
    currentRole,
  } = props;
  const { showDeleteButton, tableConfig } = viewConfig;
  const { dataKey, dataName } = tableConfig;
  const { t } = useTranslation("master");
  const dispatch = useDispatch();

  const isError = useSelector(getIsError);
  const [visible, setVisible] = React.useState(false);
console.log("isError",isError);

  const showDelete =
    showDeleteButton &&
    showDeleteButton.length > 0 &&
    showDeleteButton.includes(currentRole);

  if (!showDelete) {
    return null;
  }

  const masterName =
    selectedItems && selectedItems[0] && selectedItems[0][[dataName]]
      ? selectedItems[0][[dataName]]
      : "";
  const masterKey =
    selectedItems && selectedItems[0] && selectedItems[0][dataKey]
      ? selectedItems[0][dataKey]
      : "";

  const handleDeleteClose = () => {
    setVisible(false);
  };

  const onDelete = () => {
    dispatch(setMasterError());
    setVisible(true);
  };

  const onDeleteConfirm = () => {
    dispatch(
      deleteMasterData(
        masterType,
        title,
        masterKey,
        masterName,
        handleDeleteClose,
        t
      )
    );
    setSelectedItems([]);
    setVisible(false)
  };

  const renderText = () => {

    return (
      <>
        {t("Are you sure you want to delete the")} {t(title)}{" "}
        <span className="font-semibold">{masterName}</span>
        {t("? This action cannot be undone.")}
      </>
    );
  };
  return (
    <>
      <Button
        data-testid="delete-district-data"
        className="btn btn-danger"
        label={t("Delete")}
        severity="danger"
        icon={<img src={deleteIconImg} alt="Delete icon" />}
        outlined
        disabled={
          selectedItems.length === 0 ||
          selectedItems.length > 1 ||
          selectedItems[0].status === "Invalid"
        }
        tooltip={`Delete ${title} data`}
        tooltipOptions={{ position: "bottom", event: "both" }}
        onClick={onDelete}
      />

      <Dialog
        className="cockpit-small-dialog"
        visible={visible}
        modal={true}
        position={"center"}
        draggable={false}
        resizable={false}
        onHide={handleDeleteClose}
        closeOnEscape={false}
        header={<DeleteMasterHead title={`District`} />}
      >
        <div className="delete-body">
          <div className="mb-3">{renderText()}</div>
          <div className="mastersFormBtnGroup flex align-items-center gap-3 justify-content-center mt-4 m-2">
            <Button
              className="btn"
              data-testid="cancel"
              label={t("Cancel")}
              onClick={handleDeleteClose}
              tooltip="Cancel Delete"
              tooltipOptions={{ position: "bottom", event: "both" }}
            />
            <Button
              data-testid="delete-submit"
              className="btn btn-danger-filled"
              label={`${t("Delete")} ${t(title)}`}
              // disabled={!deleteFlag}
              onClick={onDeleteConfirm}
              tooltip="Delete"
              tooltipOptions={{ position: "bottom", event: "both" }}
            />
          </div>
        </div>
      </Dialog>
    </>
  );
};
